import { UploadFileSharp } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, Chip, Stack } from "@mui/material";
import InputField from "components/ui/inputField";
import { useFormik } from "formik";
import * as yup from "yup";
const validationSchema = yup.object({
  note: yup.string().required(""),
});
const CommentForm = ({
  postId,
  placeholder,
  btnText,
  onSubmit,
  loading,
  parent_id = 0,
  data,
}) => {
  const initialValues = {
    note: data?.note || "",
    status: 1,
    parent_id,
    knowledge_base_id: postId,
    image: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  return (
    <Box marginBottom={2}>
      <Box my={1}>
        <InputField
          name="note"
          label={placeholder}
          formik={formik}
          multiline
          rows={3}
          fullWidth
        />
      </Box>

      <Stack
        spacing={1}
        direction={"row"}
        justifyContent={"end"}
        alignItems={"center"}
        marginTop={2}
      >
        {formik.values.image ? (
          <Box>
            <Chip
              label={formik.values.image.name}
              deleteIcon={<DeleteIcon />}
              variant="outlined"
              onDelete={() => formik.setFieldValue("image", "")}
            />
          </Box>
        ) : (
          data?.image_name && (
            <Box>
              <Chip label={data?.image_name} variant="outlined" />
            </Box>
          )
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            component="label"
            startIcon={<UploadFileSharp />}
            variant="outlined"
          >
            <input
              name="image"
              type="file"
              hidden
              onChange={(e) => formik.setFieldValue("image", e.target.files[0])}
            />
            Attach File
          </Button>
        </Box>

        <Button
          variant="solid"
          onClick={formik.submitForm}
          disabled={!(formik.dirty && formik.isValid) || loading}
        >
          {btnText}
        </Button>
      </Stack>
    </Box>
  );
};

export default CommentForm;
